<template>
    <div class="back" @click="goBack()">
        <svg viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.913 16C25.0176 16 25.913 15.1046 25.913 14C25.913 12.8954 25.0176 12 23.913 12V16ZM2 14L0.616189 12.556C0.222567 12.9332 0 13.4548 0 14C0 14.5452 0.222567 15.0668 0.616189 15.444L2 14ZM15.9056 3.44398C16.703 2.67972 16.73 1.41368 15.9657 0.616189C15.2015 -0.181297 13.9354 -0.208234 13.1379 0.556024L15.9056 3.44398ZM13.1379 27.444C13.9354 28.2082 15.2015 28.1813 15.9657 27.3838C16.73 26.5863 16.703 25.3203 15.9056 24.556L13.1379 27.444ZM23.913 12H2V16H23.913V12ZM3.38381 15.444L15.9056 3.44398L13.1379 0.556024L0.616189 12.556L3.38381 15.444ZM0.616189 15.444L13.1379 27.444L15.9056 24.556L3.38381 12.556L0.616189 15.444Z" fill="#575A5D"/>
        </svg>
        Назад
    </div>
</template>

<script>
export default {
    props : ['path'],
    methods : {
        goBack(){
            if(this.path)
                this.$router.push(this.path);
            else
                this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.back{
    position: absolute;
    top: 3.241vw;
    left: 2.593vw;

    display: flex;
    align-items: center;

    background: #C8DBE1;
    border-radius: 50px;
    padding: 1.389vw 4.722vw 1.204vw 1.111vw;

    cursor: pointer;

    font-style: normal;
    font-weight: bold;
    font-size: 1.481vw;
    line-height: 1.852vw;
    color: #575A5D;

    svg{
        width: 1.204vw;
        height: auto;
        margin-right: 2.500vw;
    }
}

@media (min-width: 1281px) {
    .back{
        top: 1.5vw;
        padding: 1.2vw 3vw 1.1vw 0.9vw;
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .back{
        top: 1vw;
        left: 1.5vw;

        padding: 0.8vw 2vw 0.75vw 0.8vw;

        font-size: 1.1vw;
        line-height: 1.3vw;

        svg{
            width: 0.9vw;
            margin-right: 1.1vw;
        }
    }
}

@media (max-width: 599px){
    .back{
        top: 3.611vw;
        left: 2.778vw;

        padding: 3.611vw 3.889vw;

        font-size: 3.333vw;
        line-height: 3.889vw;

        svg{
            width: 2.778vw;
            margin-right: 1.667vw;
        }
    }
}
</style>